var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topcards-grid"},[_vm._l((_vm.visibleCards),function(card){return _c('section',{key:card.key,staticClass:"nlp-topcards",on:{"click":function($event){return _vm.handleCardClick(card.key)}}},[_c('div',{class:[
				'nlp-tc-innercontainer',
				card.bgClass,
				'fam-mont',
				'fs-13',
				'mob-fs-12',
				'fw-M',
				'color-1F1F1F',
			]},[_c('span',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(card.label)}}),_c('img',{class:[
					_vm.isLaptop && {
						h70w70: card.key == 'interviewprep' || card.key == 'takeasmnt',
						h70w75: card.key == 'buildresume',
						h58w70: card.key == 'learnupskill',
						h74w65: card.key == 'careerroadmap',
						h70w74: card.key == 'applyjobs',
					},
					!_vm.isLaptop &&
						['buildresume', 'interviewprep', 'takeasmnt'].includes(
							card.key
						) &&
						'mobtop3img',
					!_vm.isLaptop && card.key == 'applyjobs' && 'mobapplyimg',
				],attrs:{"src":card.icon,"alt":card.label}})])])}),(_vm.interviewPrepModal)?_c('InterviewPrepModal',{attrs:{"showMod":_vm.interviewPrepModal,"fromAnotherPage":true},on:{"close-modal":function($event){return _vm.hideModal()}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }